import { usePreviewMode } from "datasets/hooks/usePreviewMode";
import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import { AccessBadge } from "~/pages/manifold-nextgen/components/AccessBadge";

const ACCESS_LEVEL_LABEL: Record<DatasetAccessLevel, string> = {
  [DatasetAccessLevel.OWNER]: "Owner",
  [DatasetAccessLevel.ANALYZE]: "Analyst",
  [DatasetAccessLevel.PREVIEW]: "Preview",
};

interface AccessLevelBadgeProps {
  accessLevel: DatasetAccessLevel | null;
}

export function AccessLevelBadge({ accessLevel }: AccessLevelBadgeProps) {
  const isPreviewModeEnabled = usePreviewMode();

  if (!accessLevel) {
    return null;
  }

  const isVisible =
    accessLevel === DatasetAccessLevel.OWNER ||
    accessLevel === DatasetAccessLevel.ANALYZE ||
    (accessLevel === DatasetAccessLevel.PREVIEW && isPreviewModeEnabled);

  return <AccessBadge label={isVisible ? ACCESS_LEVEL_LABEL[accessLevel] : null} />;
}
